import { CountUp, formatHm } from '../index.js';

import type { StyleWithVars } from '../index.js';
import type { PartyWrapped } from '@mixwire/contracts';
import type { ReactElement } from 'react';

type Slide02DurationProps = {
  readonly wrapped: PartyWrapped;
};

const TOTAL_STYLE: StyleWithVars = { '--d': '900' };

export const Slide02Duration = ({ wrapped }: Slide02DurationProps): ReactElement => (
  <>
    <p className="lede rise">The party ran for</p>
    <p className="mega stretch">
      <CountUp to={wrapped.durationMs} format={formatHm} />
    </p>
    {wrapped.musicMs === 0 ? (
      <p className="lede rise" style={TOTAL_STYLE}>
        None of it was music: no track was ever logged as playing on the three channels.
      </p>
    ) : (
      <p className="lede rise" style={TOTAL_STYLE}>
        With three channels going at once, that added up to{' '}
        <b>
          <CountUp to={wrapped.musicMs} format={formatHm} delayMs={900} />
        </b>{' '}
        of music actually playing.
      </p>
    )}
  </>
);
